<template>
  <div class="sortable-item sortable-item-paragraph width-100-pr">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Párrafo <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <p
        :contenteditable="canEdit"
        plaintext-only
        :id="`index${index}`"
        @input="updateText"
        @paste.prevent="onPaste"
      >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockParagraph',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  watch: {
    time () {
      document.getElementById(`index${this.index}`).innerHTML = this.block.data.text
    }
  },

  mounted () {
    document.getElementById(`index${this.index}`).innerHTML = this.block.data.text
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    },

    onPaste (event) {
      // se pega el texto sin formato al final del texto original
      document.getElementById(`index${this.index}`).innerHTML += event.clipboardData.getData('text/plain')
      // se actualiza el item en el componente padre del editor
      this.updateText()
      // se hace foco en el elemento que ha sido editado
      document.getElementById(`index${this.index}`).focus()
      // se selecciona todo el texto del elemento
      document.execCommand('selectAll', false, null)
      // se colapsa el texto seleccionado hacia el final, lo que coloca el cursor al final del texto completo
      document.getSelection().collapseToEnd()
    },

    updateText () {
      this.$emit('updateText', this.index, document.getElementById(`index${this.index}`).innerHTML)
    }
  }
}
</script>
